import {
  messageId,
  PropertyMeta,
  ValueObjectMetaNumber,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.number().min(0);
const savedMinimalSchema = z.number().min(0);
const schema = z.number().min(0);
const savedSchema = z.number().min(0);
const jsonSchema = z.number();
/**
 * 機関ID(値オブジェクト)のメタデータ。
 *
 * 機関の主キー。 */
export const institutionIdMeta = new ValueObjectMetaNumber(
  "InstitutionId",
  "\u6A5F\u95A2ID",
  messageId("lbl.\u6A5F\u95A2ID"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
